import { forwardRef } from 'react';

import * as S from '../ApplePayExpressButton.style';

interface ApplePayButtonProps {
  'data-testid'?: string;
  isAvailable?: boolean;
}

export const ApplePayButton = forwardRef<HTMLDivElement, ApplePayButtonProps>(
  ({ 'data-testid': testId, isAvailable }, ref) => (
    <S.ButtonWrapper
      ref={ref}
      $isAvailable={isAvailable}
      data-testid={testId || 'ApplePayExpressButton'}
    />
  ),
);

ApplePayButton.displayName = 'ApplePayButton';
